export default __webpack_public_path__ + "static/media/dark-garden.b6de7f3b.webp";